import { render, staticRenderFns } from "./MarketNewsGrid.vue?vue&type=template&id=44081bef"
import script from "./MarketNewsGrid.vue?vue&type=script&lang=js"
export * from "./MarketNewsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports